<template lang="pug">
.item
  .content.d-flex.flex-column
    .head.d-flex
      img.flex-shrink-0
      h5.i_ml_2 常見問題：
    p.i_ml_8 {{ item.Question }}
  hr
  .note
    p.note.i_body_l.i_ml_8(v-html="item.Answer")
    .read_more_btn.btn_blue_ci(@click="btnClick") 繼續閱讀
</template>

<script>
export default {
  name: "FaqItem",
  props: {
    item: Object,
  },
  methods: {
    btnClick() {
      this.$router.push({
        name: "CustomerServiceFAQDetail",
        query: { id: this.item.FAQID },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/search/faq_item";

.read_more_btn.btn_blue,
.read_more_btn.btn_blue_ci {
  width: 153px;
  color: white;
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  cursor: pointer;
  margin-left: auto;
  margin-right: 0;
  text-align: center;
  font-size: 14px;
}

@media (max-width: 767px) {
  .read_more_btn.btn_blue,
  .read_more_btn.btn_blue_ci {
    width: 210px;
    height: 45px;
    line-height: 45px;
    font-size: 20px;
    border-radius: 38px;
  }
}

@media (max-width: 575px) {
  .read_more_btn.btn_blue,
  .read_more_btn.btn_blue_ci {
    width: 36.4vw;
    height: 7.8vw;
    line-height: 7.8vw;
    font-size: 3.5vw;
    border-radius: 6.6vw;
  }
}
</style>
